// Where the visit came from, for the stats of the sign-ups (SignupAcquisition on the API): the first page of the
// visit, the site the visitor came from and the utm_* parameters of that page. Kept in the memory of the page only
// (no cookie, no storage): read once when the app starts, sent with the sign-up request.
export interface SignupAcquisitionData {
  landing: string
  referrer: string
  utmSource?: string
  utmMedium?: string
  utmCampaign?: string
}

let visit: SignupAcquisitionData | null = null

export const recordVisit = () => {
  if (visit || typeof window === 'undefined') return
  const params = new URLSearchParams(window.location.search)
  const utm = (name: string) => params.get(name)?.slice(0, 100) || undefined
  visit = {
    landing: window.location.pathname.slice(0, 255),
    referrer: document.referrer.slice(0, 500),
    utmSource: utm('utm_source'),
    utmMedium: utm('utm_medium'),
    utmCampaign: utm('utm_campaign'),
  }
}

export const signupAcquisition = (): SignupAcquisitionData | undefined =>
  visit ?? undefined
